angular.module('app').directive('researcherResearchComplete', [
  () => {
    let link = (scope) => {
      scope.isVisible = {
        suggestions: false,
      };

      // dummy data
      scope.categories = [
        "1-9", "A-C", "D-F", "G-I", "J-L", "M-O", "P-R", "S-U", "V-Z"
      ];

      scope.categoriesData = [
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['a', 'b', 'c'],
        ['d', 'e', 'f'],
        ['g', 'h', 'i'],
        ['j', 'k', 'l'],
        ['m', 'n', 'o'],
        ['p', 'q', 'r'],
        ['s', 't', 'u'],
        ['v', 'w', 'x', 'y', 'z']
      ];

      scope.filteredChoices = scope.researchers;

      scope.selectedCategoryIndex = 0;
      scope.categorySelect = index => { 
        scope.selectedCategoryIndex = index;
        scope.enteredtext = scope.categories[index].toLowerCase().substr(0, 1);
        scope.searchTitle();
      };

      scope.searchTitle = () => {
        if (scope.enteredtext.length < 0) {
          return;
        }
        scope.searchhandler('researcher', scope.enteredtext, 1);
      };

      scope.filterItemsByCategory = () => {
        if (!scope.enteredtext.length) {
          scope.isVisible.suggestions = false;
          return;
        }
        scope.isVisible.suggestions = true;

        scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.toLowerCase().substr(0, 1)));

        scope.filteredChoices = scope.filteredChoices.filter(attrib => {
          return scope.categoriesData[scope.selectedCategoryIndex].includes(attrib.name.toLowerCase().substr(0, 1));
        });
        scope.filteredChoices = scope.filteredChoices.filter((item, index, self) =>
          index === self.findIndex((t) => (
            t.id === item.id
          ))
        )
      };

      scope.selectItem = (choice) => {
        scope.enteredtext = choice.name;
        scope.isVisible.suggestions = false;
        scope.selecthandle(scope.selecttype, choice);
      };

      scope.filterItems = () => {  
        if (!scope.enteredtext.length) {
          scope.isVisible.suggestions = false;
          return;
        }
        scope.isVisible.suggestions = true;
        scope.filteredChoices = scope.researchers;
        scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.substr(0, 1))); 
      }; 

      scope.$watch('researchers', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.researchers = newValue;
          scope.filterItems();
        }
      }, true);

      scope.$watch('enteredtext', function (enteredtext) {
        if (!enteredtext) {
          scope.isVisible.suggestions = false;
        }
      }, true);
    };
    return {
      restrict: "E",
      templateUrl: "app/directives/dbColorResearchData/researcherResearchComplete/researcherResearchCompleteView.html",
      link: link,
      scope: {
        enteredtext: "=",
        placeholder: "=",
        selecthandle: "=",
        selecttype: "=",
        searchhandler: "=",
        researchers: "=",
      }
    };
  }
]);
